import { Api } from 'utils';

class AuthService {
	
	static login = async (params?: any) => Api.createResponse('superadmin/auth/login',params);
	
}

export default AuthService;